<template>
<div>
  <div v-if="client==0">
    <br>
    <h3 v-if="liste.length!==0">1. Choisis le client</h3>
    <div v-if="liste.length===0">
    <h3 >PAS DE CLIENT AU PLANNING AUJOURD'HUI</h3><br>
    <v-img class="mx-auto" max-width="300px" :src="sadGIF"></v-img>

    </div>
  <div v-for="item in liste" :key="item.poscli_ID" >
   <v-btn @click="setClient(item)" class="ma-3"

      dark
      color="success">
      <v-icon>mdi-arrow-right-bold</v-icon> {{ item.Cont_Nom }}</v-btn>
  </div>
</div>
<v-btn  v-if="client!=0" @click="setClient(raz)"

      dark
      color="warning"><v-icon

      >
        mdi-arrow-left-bold
      </v-icon>revenir au choix de clients</v-btn>
<br><br>
 <v-spacer></v-spacer>
<div   v-if="client!=0">
  <h3>2. Prends des photos sur {{ NomClient }} </h3>

  <v-expand-transition  v-if="urlpic.length>1">
<v-img class="mx-auto mt-1 mb-4"
  max-width="300"
   :src="urlpic"
>
</v-img>

</v-expand-transition>

 <v-textarea
          outlined
          prepend-inner-icon="mdi-comment"
          name="input-7-4"
          label="Ton commentaire"
          v-model="commentaire"
v-if="!nocomment"
          class="ml-10 mr-10"
        ></v-textarea>
        <v-btn class="mb-4" v-if="commentaire.length==0" @click="nocomment=!nocomment"><v-icon>mdi-comment-remove-outline</v-icon> {{nocomment ? 'JE VEUX FAIRE UN COMMENTAIRE':'PAS DE COMMENTAIRE'  }}</v-btn><br>
<!-- <v-btn class="mx-2" fab dark color="success" @click="tackePicture">
      <v-icon dark>
        mdi-camera
      </v-icon>
    </v-btn> -->

<v-btn @click="click1" color="success" v-if="commentaire.length>0 || nocomment"> <v-icon dark>
        mdi-camera
      </v-icon>  {{ diddoneone ? 'On en prend un autre ?':'Prends une photo'}}</v-btn>
           <input type="file" ref="input1"
            style="display: none"
            @change="previewImage" accept="image/*" >
         </div>

    <v-snackbar
      absolute
      centered
      :value.sync="info"
      :color="color"
      elevation="24"
    >
      {{ alertMsg }}
    </v-snackbar>
<v-overlay :value="overlay"></v-overlay>
</div>
</template>

<script>
import {minuAPI} from '../services/http-common'
import { Plugins, CameraResultType } from '@capacitor/core'
import * as fb from '../firebase'

import Swal from 'sweetalert2'

const { Camera, Storage } = Plugins
export default {
  data: () => ({
    color: 'success',
    urlpic: '',
    alertMsg: '',
    info: false,
    uid: fb.auth.currentUser.uid,
    uemail: fb.auth.currentUser.email,
    matime: '',
    urli: '',
    client: 0,
    NomClient: '',
    liste: [],
    dbID: 0,
    raz: {'id': 0, 'ID': 0, 'nom': ''},
    erroorr: '',
    uploadValue: 0,
    img1: null,
    imageData: '',
    commentaire: '',
    nocomment: false,
    diddoneone: false,
    overlay: false,
    sadGIF: require('../assets/sad.gif')

  }),

  beforeMount () {
    this.getMinu()
    this.getContact()
  },

  methods: {
    async getContact () {
      const ret = await Storage.get({
        key: 'contact'
      })
      console.log(ret)
      if (ret.value != null) {
        const jso = JSON.parse(ret.value)

        console.log(jso)
        this.setClient(jso)
      }
    },
    previewImage (event) {
      this.uploadValue = 0
      this.img1 = null
      this.imageData = event.target.files[0]
      this.onUpload()
    },
    click1 () {
      this.$refs.input1.click()
    },
    setClient (item) {
      console.log(item.id)
      this.client = item.id
      this.dbID = item.ID
      this.NomClient = item.nom
      if (item.id === 0) Storage.remove({key: 'contact'})
    },

    bravo () {
      Swal.fire({
        title: 'Bravo !',
        text: 'C\'est du grand art, tu peux en prendre une autre',
        icon: 'success',
        button: 'ok'
      })
    },
    async sendFirebase (url) {
      await fb.postsCollection.add({
        createdOn: new Date(),
        url: url,
        client: this.client,
        commentaire: this.commentaire,
        userId: fb.auth.currentUser.uid
      })
    },
    onUpload () {
      this.info = true
      this.overlay = true
      this.alertMsg = 'ENVOI DE LA PHOTO ...'
      this.img1 = null
      this.matime = Date.now()
      const storageRef = fb.storage.ref(`${this.uid}_${this.matime}.png`).put(this.imageData)
      storageRef.on(`state_changed`, snapshot => {
        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => { console.log(error.message) },
      () => {
        this.uploadValue = 100
        storageRef.snapshot.ref.getDownloadURL().then((url) => {
          this.img1 = url
          this.sendFirebase(url)
          this.diddoneone = true
          this.overlay = false
          this.urlpic = url
          this.info = false
          this.PostMinu({url: url, nom: this.NomClient, client: this.client, ID: this.dbID, user: fb.auth.currentUser.email, cmt: this.commentaire})
        })
      }
      )
    },
    async tackePicture () {
      const image = await Camera.getPhoto({
        quality: 100,
        allowEditing: false,
        resultType: CameraResultType.Base64,
        encodingType: 1,
        mediaType: 0
      }).catch((e) => {
        throw new Error(e)
      })
      this.matime = Date.now()
      this.info = true
      this.alertMsg = 'ENVOI PHOTO ...'
      fb.storage.ref('/photos').child(`${this.uid}_${this.matime}.png`).putString(image.base64String, 'base64', {contentType: 'image/png'}).then(snapshot => {
        return snapshot.ref.getDownloadURL() // Will return a promise with the download link
      })

        .then(downloadURL => {
          console.log(`Successfully uploaded file and got download link - ${downloadURL}`)

          this.sendFirebase(downloadURL)

          this.urlpic = downloadURL
          this.info = false
          this.PostMinu({url: downloadURL, client: this.client, ID: this.dbID, user: fb.auth.currentUser.email})
        })
    },

    async getMinu () {
      minuAPI.post(``, {email: this.uemail})
        .then(response => {
          console.log(response.data)
          this.liste = response.data
        })
        .catch(e => {
          this.errors.push(e)
          this.erroorr = e
        })
    },

    async PostMinu (params) {
      this.alertMsg = 'ENVOI INFO'
      this.info = true
      minuAPI.post('upload.php', params).then((response) => {
        console.log(response.data)

        this.info = false
        this.bravo()
      }, (error) => {
        console.log(error)
        this.erroorr = error
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/MainPage.vue